module.exports = __webpack_public_path__ + "img/2025-05-09c_8.353c1f80.jpg";